import React from "react";
import { IFilterSelectButtonProps, TOptionsItem } from "../types";

const FilterSelectButton = (props: IFilterSelectButtonProps) => {
  const { selectedOptions, name, placeholder, showSlectedNum } = props || {};

  const renderSelected = (selectedOptions: Array<TOptionsItem>) => {
    if (selectedOptions?.length > showSlectedNum) return selectedOptions?.length;
    return (
      <div className='dbd-select-button-value-only-text'>
        {selectedOptions?.map((item, index) => {
          // 获取名称，过滤html代码
          const text = item?.text?.replace?.(/<[^>]+>/gim, '');
          const newText = `${text}${index !== selectedOptions.length - 1 ? ',' : ''}`;
          // 统一有图标则展示到选择框内
          return item?.icon ? <span key={index}>{item?.icon && <img src={item.icon} />} {newText}</span> : newText;
        })}
      </div>
    );
  };

  return (
    <div className={`db-filter-select-button`}>
      <span className="db-filter-select-button-text">
        {name ? name : ''}
      </span>
      <span className="db-filter-select-button-value">
        {selectedOptions?.length ? renderSelected(selectedOptions) : placeholder}
      </span>
    </div>
  );
};

export default FilterSelectButton;